import * as React from 'react'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import {
  MdOutlineElectricCar,
  MdOutlineElectricBolt,
  MdOutlineSolarPower,
  MdOutlineBatteryChargingFull,
  MdHandyman,
} from 'react-icons/md'
import { Heading, Text } from '@radix-ui/themes'

import { config } from '~/commerce-config'
import { INDEX_I18NEXT } from '~/routes/($lang)._index/index.component'


const services = [
  { Icon: MdOutlineSolarPower, label: 'module' },
  { Icon: MdOutlineBatteryChargingFull, label: 'memory' },
  { Icon: MdOutlineElectricBolt, label: 'inverter' },
  { Icon: MdHandyman, label: 'substructure' },
  { Icon: MdOutlineElectricCar, label: 'wallbox' },
]


const Services: React.FC = () => {
  const { t } = useTranslation(INDEX_I18NEXT.routeIndex)

  return (
    <div className="flex flex-col gap-y-12 items-center my-12">
      <div className="flex flex-col items-center gap-y-2">
        <Heading color="green" weight="medium" size="7">
          {t(`common.services.title`)}
        </Heading>
        <Text color="gray" className="text-center">
          {parse(t(`common.services.subtitle`))}
        </Text>
      </div>
      <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-20 gap-y-10">
        {services.map(({ Icon, label }) => (
          <li key={label} className="group flex flex-col gap-y-4 items-center">
            <div className="w-20 h-20 bg-white shadow-lg shadow-accent-4 rounded-full flex justify-center items-center transition duration-500 ease-in-out group-hover:-translate-y-2 group-hover:shadow-xl group-hover:shadow-accent-5">
              <Icon size="2.2em" className="text-accent-9" />
            </div>
            <Heading weight="regular" size="5">
              {t(`common.services.${label}.title`)}
            </Heading>
            <Text weight="light" size="3" color="gray" className="text-center">
              {t(`common.services.${label}.description`)}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}


export { Services }
